import type { ReactNode } from "react";
import { IntlProvider } from "react-intl";
import { useUser } from "../user-context";
import { getBrowserLang, localeToTranslations } from "./intl.utils";
import { useSyncLocale } from "./use-sync-locale";

type ShellIntlProviderProps = { children: ReactNode };
export const ShellIntlProvider = ({ children }: ShellIntlProviderProps) => {
  const user = useUser();
  const locale = useSyncLocale({ user });
  const translations = localeToTranslations(locale);
  return (
    <IntlProvider locale={locale} messages={translations}>
      {children}
    </IntlProvider>
  );
};

export const UserlessIntlProvider = ({ children }: ShellIntlProviderProps) => {
  const locale = getBrowserLang();
  const translations = localeToTranslations(locale);
  return (
    <IntlProvider locale={locale} messages={translations}>
      {children}
    </IntlProvider>
  );
};
